import "./index.css";
import Body from "./comp/body";
export function Main_Layout() {

  return (
    <>
      <Body />
    </>
  );
}

export default Main_Layout;




